import { Offer } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import { getFormatedPrice, getNaturalDate } from '../helpers'
import {
  CustomText,
  CustomHeaderText,
  OfferStatusColumn,
  OffersActionColumn,
  OffersColumnMovileView, SaleOfferProjectColumn,
} from 'src/components'

const offersListColumns: ColumnsType<Offer> = [
  {
    title: () => <CustomHeaderText text='card.Project' />,
    responsive: ['sm'],
    sorter: (a: Offer, b: Offer) => a.project_name?.length - b.project_name?.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, offer) => {
      return (
        <SaleOfferProjectColumn offer={offer} />
      )
    }
  },
  {
    title: () => <CustomHeaderText text='developers.Date' isCentered />,
    responsive: ['sm'],
    sorter: (a: Offer, b: Offer) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <div className='centered-div'>
      <CustomText label={getNaturalDate(record.date)} />
    </div>
  },
  {
    title: () => <CustomHeaderText text='Offers.Offer' isCentered />,
    responsive: ['sm'],
    sorter: (a: Offer, b: Offer) => a.price - b.price,
    sortDirections: ['descend', 'ascend'],
    render: (_, offer) => {
      const value = `${offer.amount} tCO₂ @ ${getFormatedPrice(offer.price, offer.currency)}`
      return <div className='centered-div'>
        <CustomText label={value} />
      </div>
    }
  },
  {
    title: () => <CustomHeaderText text={'Offers.Total'} isCentered />,
    responsive: ['sm'],
    sorter: (a, b) => {
      const a_amount = a.price * b.amount
      const b_amount = b.price * b.amount
      return a_amount - b_amount
    },
    render: (_, offer: Offer) => {
      const amount = offer.amount * offer.price
      const value = getFormatedPrice(amount, offer.currency)
      return (
        <div className='centered-div'>
          <CustomText label={value} />
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'Summary.Status'} isCentered />,
    responsive: ['sm'],
    render: (_, offer: Offer) => <OfferStatusColumn offer={offer} />,
  },
  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered />,
    align: 'center',
    responsive: ['sm'],
    render: (_, offer) => <OffersActionColumn offer={offer} />,
  },
  // Mobile View
  {
    title: () => <CustomHeaderText text={'Offers.Offer'} isCentered />,
    sorter: (a: Offer, b: Offer) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA.getTime() - dateB.getTime()
    },
    responsive: ['xs'],
    render: (_, offer) => <OffersColumnMovileView offer={offer} />,
  },
]

export default offersListColumns
